export default __webpack_public_path__ + "static/media/impersonate.837887f3.svg";